<template>
  <div id="app">
    <!-- 导航栏组件 -->
    <NavbarComponent />
    
    <!-- 路由视图 -->
    <router-view />
    
    <!-- AI对话组件 -->
    <AiChatComponent />
  </div>
</template>

<script>
import NavbarComponent from './components/NavbarComponent.vue'
import AiChatComponent from './components/AiChatComponent.vue'

export default {
  name: 'App',
  components: {
    NavbarComponent,
    AiChatComponent
  }
}
</script>

<style>
/* 全局样式已在main.js中引入 */
#app {
  width: 100%;
  min-height: 100vh;
}
</style> 